// extracted by mini-css-extract-plugin
module.exports = {"rectangles":"RectangleBox_rectangles__3yn99","rec":"RectangleBox_rec__11oo5"};